'use client';

import React, { type Ref } from 'react';

import { Body } from '@depop/web-thrift-ui/Typography';
import { useTranslations } from 'next-intl';

import { UserSearchItem } from '../UserSearchItem';

import styles from './styles.module.css';

import {
  VARIANT_A_IDENTIFIER,
  VARIANT_B_IDENTIFIER,
} from '@/modules/experiments/config';
import { useExperiments } from '@/modules/experiments/useExperiments';
import { type UserSearchResponse } from '@/modules/search/aliases';

type UserSearchListProps = {
  userSuggestions: UserSearchResponse;
  userSuggestionsRef?: Ref<HTMLUListElement>;
};

export function UserSearchList({
  userSuggestions,
  userSuggestionsRef,
}: UserSearchListProps) {
  const t = useTranslations('common');

  const { web_6746_search_for_sellers } = useExperiments([
    'web_6746_search_for_sellers',
  ]);

  const isSearchSellersVariantA =
    web_6746_search_for_sellers === VARIANT_A_IDENTIFIER;
  const isSearchSellersVariantB =
    web_6746_search_for_sellers === VARIANT_B_IDENTIFIER;

  const isUserSuggestionsAvailable = userSuggestions.length;

  if (isSearchSellersVariantB && isUserSuggestionsAvailable) {
    return (
      <ul ref={userSuggestionsRef}>
        {userSuggestions[0] && <UserSearchItem {...userSuggestions[0]} />}
      </ul>
    );
  }

  if (isSearchSellersVariantA && isUserSuggestionsAvailable) {
    return (
      <ul ref={userSuggestionsRef}>
        <Body variant="sm-bold" className={styles.userSuggestionTitle}>
          {t('People')}
        </Body>
        {userSuggestions.slice(0, 5).map((user) => (
          <UserSearchItem key={user.id} {...user} />
        ))}
      </ul>
    );
  }
}
